import styled from "styled-components";

const Style = styled.div`
  width: 99px;
  height: 10px;
  border-radius: 8px;
  background: #F3F4F6;
  overflow: hidden;

  .bar {
    height: 100%;
    background: var(--color-primary-70);
  }
`;

export default function ProgressBar({ percentage = 0 }) {
  return (
    <Style>
      <div className="bar" style={{ width: percentage }} />
    </Style>
  );
}
